import { makeVar } from '@apollo/client/cache/inmemory/reactiveVars';

import { MeQuery } from '@/graphql/generated';
import { ChecklistItem, ReplacedJobRole } from '@/lib/types';

export const currentUserVar = makeVar<MeQuery['me'] | null>(null);

export const checkListCompletionVar = makeVar<ChecklistItem['id'][]>([]);

export const replacedJobRoleVar = makeVar<ReplacedJobRole | null>(null);
